import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation, EffectFade } from "swiper/modules";
import {
  SITE,
  WHATSAPP_LINK,
  SERVICES,
  EXPERTS,
  TESTIMONIALS,
  WHY_US,
} from "../data/siteConfig";

const HERO_SLIDES = [
  {
    image:
      "https://images.unsplash.com/photo-1726250873216-7fcf000fa796?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBjb3Jwb3JhdGUlMjBtZWV0aW5nJTIwdHJhaW5pbmclMjBzZXNzaW9ufGVufDB8fHx8MTc3NjYzNjA5Mnww&ixlib=rb-4.1.0&q=85",
    eyebrow: "POSH Act, 2013 · Certified Experts",
    title: (
      <>
        POSH Compliance & <span className="hl">Corporate Training</span>{" "}
        Experts
      </>
    ),
    sub: "Ensure legal compliance and create safe, respectful workplaces with expert guidance from certified POSH trainers and Company Secretaries.",
    primary: { to: "/contact", label: "Get Consultation", icon: "bi-arrow-right" },
    secondary: {
      href: WHATSAPP_LINK,
      label: "WhatsApp Now",
      icon: "bi-whatsapp",
      ext: true,
    },
  },
  {
    image:
      "https://images.unsplash.com/photo-1726250873194-e9aefd3667ba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBjb3Jwb3JhdGUlMjBtZWV0aW5nJTIwdHJhaW5pbmclMjBzZXNzaW9ufGVufDB8fHx8MTc3NjYzNjA5Mnww&ixlib=rb-4.1.0&q=85",
    eyebrow: "End-to-End Compliance",
    title: (
      <>
        Make Your Workplace <span className="hl">Safe & Legally Compliant</span>
      </>
    ),
    sub: "Expert POSH training, IC formation, and compliance solutions tailored for your organization — from policy drafting to annual filings.",
    primary: { to: "/services", label: "Our Services", icon: "bi-grid" },
    secondary: {
      href: SITE.phoneHref,
      label: "Call Now",
      icon: "bi-telephone-fill",
      ext: true,
    },
  },
  {
    image:
      "https://images.unsplash.com/photo-1565946590329-fc70903f0ba0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjBjb3Jwb3JhdGUlMjBtZWV0aW5nJTIwdHJhaW5pbmclMjBzZXNzaW9ufGVufDB8fHx8MTc3NjYzNjA5Mnww&ixlib=rb-4.1.0&q=85",
    eyebrow: "Trusted By Corporates & NGOs",
    title: (
      <>
        Trusted POSH Advisors for{" "}
        <span className="hl">Organizations</span>
      </>
    ),
    sub: "Helping businesses build respectful, inclusive, and harassment-free workplaces — with practical legal expertise.",
    primary: { to: "/contact", label: "Contact Us", icon: "bi-envelope" },
    secondary: {
      href: WHATSAPP_LINK,
      label: "WhatsApp Now",
      icon: "bi-whatsapp",
      ext: true,
    },
  },
];

const Home = () => {
  return (
     <>
     <Helmet>
        <title>
          POSH Compliance Services in Delhi NCR | POSH Compliances
        </title>

        <meta
          name="description"
          content="Expert POSH compliance, IC training, workplace safety and annual POSH filing services across Delhi NCR, Noida, Ghaziabad and Gurgaon."
        />

        <meta
          name="keywords"
          content="POSH compliance Delhi NCR, POSH training Noida, POSH consultant Gurgaon, IC formation Ghaziabad"
        />
      </Helmet>
     
  <div data-testid="home-page">
        {/* ================= HERO ================= */}
        <section className="rs-hero" data-testid="hero-slider">
          <Swiper
            modules={[Autoplay, Pagination, Navigation, EffectFade]}
            effect="fade"
            fadeEffect={{ crossFade: true }}
            loop
            speed={900}
            autoplay={{ delay: 5500, disableOnInteraction: false }}
            pagination={{ clickable: true }}
            navigation
          >
            {HERO_SLIDES.map((s, idx) => (
              <SwiperSlide key={idx}>
                <div
                  className="rs-hero-slide"
                  style={{ backgroundImage: `url(${s.image})` }}
                >
                  <div className="container">
                    <div className="rs-hero-content">
                      <div className="rs-hero-eyebrow">
                        <i className="bi bi-shield-check"></i>
                        {s.eyebrow}
                      </div>
                      <h1 className="rs-hero-title">{s.title}</h1>
                      <p className="rs-hero-sub">{s.sub}</p>
                      <div className="rs-hero-ctas">
                        <Link
                          to={s.primary.to}
                          className="btn btn-rs-primary"
                          data-testid={`hero-cta-primary-${idx}`}
                        >
                          {s.primary.label}
                          <i className={`bi ${s.primary.icon}`}></i>
                        </Link>
                        <a
                          href={s.secondary.href}
                          target={s.secondary.ext ? "_blank" : undefined}
                          rel="noreferrer"
                          className="btn btn-rs-ghost"
                          data-testid={`hero-cta-secondary-${idx}`}
                        >
                          <i className={`bi ${s.secondary.icon}`}></i>
                          {s.secondary.label}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </section>

        {/* ================= TRUST STRIP ================= */}
        <section className="rs-trust">
          <div className="container">
            <div className="row">
              {[
                { icon: "bi-award-fill", title: "Certified POSH Trainers", sub: "Company Secretaries with LL.B." },
                { icon: "bi-buildings", title: "Corporate & NGO Clients", sub: "Across India" },
                { icon: "bi-shield-check", title: "End-to-End Compliance", sub: "Policy · IC · Training · Filings" },
                { icon: "bi-headset", title: "Responsive Support", sub: "Call · WhatsApp · Email" },
              ].map((t, i) => (
                <div className="col-lg-3 col-md-6" key={i}>
                  <div className="rs-trust-item" data-aos="fade-up" data-aos-delay={i * 80}>
                    <i className={`bi ${t.icon}`}></i>
                    <div>
                      <strong>{t.title}</strong>
                      <small>{t.sub}</small>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ================= PROBLEM ================= */}
        <section className="section" data-testid="problem-section">
          <div className="container">
            <div className="row align-items-center g-5">
              <div className="col-lg-6" data-aos="fade-right">
                <span className="eyebrow">The Problem</span>
                <h2 className="section-title">
                  Is Your Organization{" "}
                  <span className="accent">POSH Compliant?</span>
                </h2>
                <div className="rs-divider"></div>
                <p className="section-lead">
                  Many organizations are still unaware of mandatory POSH
                  compliance requirements under the Sexual Harassment of Women
                  at Workplace Act, 2013. Non-compliance can lead to serious
                  legal consequences, financial penalties, and reputational
                  damage.
                </p>
                <p className="section-lead mt-3">
                  A safe workplace is essential for employee well-being,
                  productivity, and growth.
                </p>
                <div className="d-flex flex-wrap gap-3 mt-4">
                  <Link to="/contact" className="btn btn-rs-primary" data-testid="problem-cta">
                    Get Free Compliance Check <i className="bi bi-arrow-right"></i>
                  </Link>
                  <a href={SITE.phoneHref} className="btn btn-rs-outline">
                    <i className="bi bi-telephone-fill"></i> Call {SITE.phone}
                  </a>
                </div>
              </div>
              <div className="col-lg-6" data-aos="fade-left">
                <div className="rs-problem">
                  <div className="rs-problem-icon">
                    <i className="bi bi-exclamation-triangle-fill"></i>
                  </div>
                  <h4>Non-Compliance Risks</h4>
                  <ul className="list-unstyled mt-3 mb-0">
                    {[
                      "Monetary penalties up to ₹50,000 per violation",
                      "Cancellation of business licenses",
                      "Reputational and brand damage",
                      "Increased attrition & low employee morale",
                      "Legal proceedings & director liability",
                    ].map((r, i) => (
                      <li
                        key={i}
                        className="d-flex align-items-start gap-3 py-2"
                        style={{ color: "var(--rs-text)" }}
                      >
                        <i
                          className="bi bi-x-circle-fill"
                          style={{ color: "#d9534f", fontSize: "1.1rem", marginTop: "3px" }}
                        ></i>
                        <span>{r}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ================= SERVICES ================= */}
        <section className="section section-alt" data-testid="services-section">
          <div className="container">
            <div className="text-center mb-5" data-aos="fade-up">
              <span className="eyebrow">What We Do</span>
              <h2 className="section-title">Our Services</h2>
              <div className="rs-divider"></div>
              <p className="section-lead mx-auto">
                Comprehensive POSH compliance, training and legal advisory — designed
                for Indian corporates, startups and NGOs.
              </p>
            </div>

            <div className="row g-4">
              {SERVICES.slice(0, 4).map((s, i) => (
                <div className="col-lg-3 col-md-6" key={i}>
                  <div
                    className="rs-card"
                    data-aos="fade-up"
                    data-aos-delay={i * 80}
                    data-testid={`home-service-${i}`}
                  >
                    <div className="rs-icon">
                      <i className={`bi ${s.icon}`}></i>
                    </div>
                    <h5>{s.title}</h5>
                    <p>{s.desc}</p>
                    <Link to="/services" className="rs-card-link">
                      Learn more <i className="bi bi-arrow-right"></i>
                    </Link>
                  </div>
                </div>
              ))}
            </div>

            <div className="text-center mt-5" data-aos="fade-up">
              <Link to="/services" className="btn btn-rs-primary">
                View All Services <i className="bi bi-arrow-right"></i>
              </Link>
            </div>
          </div>
        </section>

        {/* ================= EXPERTS ================= */}
        <section className="section" data-testid="experts-section">
          <div className="container">
            <div className="text-center mb-5" data-aos="fade-up">
              <span className="eyebrow">Leadership</span>
              <h2 className="section-title">Meet Our Experts</h2>
              <div className="rs-divider"></div>
              <p className="section-lead mx-auto">
                Certified Company Secretaries and POSH professionals bringing
                deep legal expertise and practical workplace insights.
              </p>
            </div>

            <div className="row g-4 justify-content-center">
              {EXPERTS.map((e, i) => (
                <div className="col-lg-6 col-md-10" key={i}>
                  <div
                    className="rs-expert"
                    data-aos="fade-up"
                    data-aos-delay={i * 120}
                    data-testid={`expert-card-${i}`}
                  >
                    <img src={e.image} alt={e.name} className="rs-expert-img" />
                    <div className="rs-expert-body">
                      <span className="rs-expert-role">{e.role}</span>
                      <h4>{e.name}</h4>
                      <p>{e.bio}</p>
                      <div className="rs-expert-tags">
                        {e.tags.map((t, idx) => (
                          <span key={idx} className="rs-tag">{t}</span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ================= WHY CHOOSE US ================= */}
        <section className="section section-alt" data-testid="why-us-section">
          <div className="container">
            <div className="row align-items-center g-5">
              <div className="col-lg-6" data-aos="fade-right">
                <span className="eyebrow">Why Choose Us</span>
                <h2 className="section-title">
                  Built on <span className="accent">Trust, Expertise</span> &
                  Results
                </h2>
                <div className="rs-divider"></div>
                <p className="section-lead">
                  We combine deep statutory knowledge with ground-level
                  workplace realities to deliver compliance that actually works.
                </p>

                <div className="mt-3">
                  {WHY_US.map((w, i) => (
                    <div
                      className="rs-why-item"
                      key={i}
                      data-aos="fade-up"
                      data-aos-delay={i * 80}
                    >
                      <div className="rs-why-check">
                        <i className={`bi ${w.icon}`}></i>
                      </div>
                      <div>
                        <h6>{w.title}</h6>
                        <p>{w.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="col-lg-6" data-aos="fade-left">
                <div className="rs-why-visual">
                  <img
                    src="/images/4.jpg"
                    alt="Professional office"
                  />
                  <div className="rs-floating-badge rs-badge-bl">
                    <div className="num">8+</div>
                    <small>Years of Corporate<br />Legal Experience</small>
                  </div>
                  <div className="rs-floating-badge rs-badge-tr">
                    <div className="num">100%</div>
                    <small>POSH Compliance<br />Delivery</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ================= TESTIMONIALS ================= */}
        <section className="section" data-testid="testimonials-section">
          <div className="container">
            <div className="text-center mb-5" data-aos="fade-up">
              <span className="eyebrow">Client Voices</span>
              <h2 className="section-title">What Our Clients Say</h2>
              <div className="rs-divider"></div>
              <p className="section-lead mx-auto">
                Trusted by HR leaders, founders and NGOs across India.
              </p>
            </div>

            <Swiper
              modules={[Autoplay, Pagination]}
              spaceBetween={24}
              slidesPerView={1}
              loop
              autoplay={{ delay: 5000, disableOnInteraction: false }}
              pagination={{ clickable: true }}
              breakpoints={{
                768: { slidesPerView: 2 },
                1200: { slidesPerView: 3 },
              }}
              style={{ paddingBottom: "50px" }}
            >
              {TESTIMONIALS.map((t, i) => (
                <SwiperSlide key={i}>
                  <div className="rs-testimonial" data-testid={`testimonial-${i}`}>
                    <span className="quote-mark">&ldquo;</span>
                    <div className="rs-stars">
                      {[1, 2, 3, 4, 5].map((star) => (
                        <i
                          key={star}
                          className={`bi ${
                            star <= Math.floor(t.rating)
                              ? "bi-star-fill"
                              : star - t.rating <= 0.5
                              ? "bi-star-half"
                              : "bi-star"
                          }`}
                        ></i>
                      ))}
                    </div>
                    <p>{t.quote}</p>
                    <div className="rs-testimonial-foot">
                      <div className="rs-testimonial-avatar">{t.initials}</div>
                      <div>
                        <strong>{t.name}</strong>
                        <small>{t.role}</small>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </section>

        {/* ================= CTA ================= */}
        <section className="section section-alt" data-testid="home-cta-section">
          <div className="container">
            <div className="rs-cta" data-aos="zoom-in">
              <div className="row align-items-center g-4">
                <div className="col-lg-8">
                  <span
                    className="eyebrow"
                    style={{
                      background: "rgba(255,255,255,0.12)",
                      color: "#fff",
                    }}
                  >
                    Take the Next Step
                  </span>
                  <h2>Ensure POSH Compliance Today</h2>
                  <p>
                    Talk to our certified POSH trainers and Company Secretaries.
                    Free discovery call — no obligations.
                  </p>
                </div>
                <div className="col-lg-4">
                  <div className="rs-cta-actions">
                    <a
                      href={SITE.phoneHref}
                      className="btn btn-rs-accent"
                      data-testid="cta-call-btn"
                    >
                      <i className="bi bi-telephone-fill"></i> Call Now
                    </a>
                    <a
                      href={WHATSAPP_LINK}
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-rs-ghost"
                      data-testid="cta-whatsapp-btn"
                    >
                      <i className="bi bi-whatsapp"></i> WhatsApp Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
  </div>
  </>
  );
  
};

export default Home;
